import React, { useEffect, useContext } from "react";
import { useImmer } from "use-immer";
import moment from "moment";
import { successMessage, errorMessage } from "../../../utils";
import { getWebOrderFeeHistory } from "../api/SettingsApi";

export const useSettingsFeeHistory = () => {

    const [state, setState] = useImmer({
        isLoading: true,
        dataList: [],
        selectedData: null,
        selectedDetails: null,
        isModalOpen: false,
    });

    useEffect(() => {
        if (state.dataList.length === 0) {
            handleGetWebOrderFeeHistory();
        }
    }, []);


    const handleGetWebOrderFeeHistory = async () => {
        try {
            const res = await getWebOrderFeeHistory();
            if (res.success) {
                setState((draft) => {
                    draft.dataList = res.data;
                    draft.isLoading = false;
                });
            } else {
                errorMessage(res.message);
            }
        } catch (err) {
            setState((draft) => {
                draft.isLoading = false;
            });
        }
    };

    const handleModal = (isOpen, data) => {
        if (isOpen && data) {
            generateChangesTable(data);
        } else {
            setState((draft) => {
                draft.isModalOpen = isOpen;
                draft.selectedData = null;
                draft.selectedDetails = null;
            });
        }

    };
    const generateChangesTable = (data) => {
        const changes = data?.properties || [];

        // Key to display name mapping
        const keyNameMapping = {
            fee_apply_date_type: "Fee Type",
            fee_apply_date_value: "Value",
            fee_status: "Action",
            fee_apply_date: "Effective From",
        };


        const formatDate = (dateString) => {
            if (!dateString) return "--";
            return moment(dateString).format('DD MMM YYYY');
        };

        const capitalizeWords = (str) => {
            if (!str) return str;
            return str.toString().split(' ').map(word =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            ).join(' ');
        };

        const result = Object.keys(changes.attributes)
            .filter(key => key !== 'fee_value' && key !== 'fee_type')
            .filter(key => changes.old === null ? changes.attributes[key] !== null : true)
            .map(key => ({
                keys: keyNameMapping[key] || key,
                new: key === 'fee_status'
                    ? (changes.attributes[key] ? 'Enable' : 'Disable')
                    : key === 'fee_apply_date'
                        ? formatDate(changes.attributes[key])
                        : capitalizeWords(changes.attributes[key]),
                old: key === 'fee_status'
                    ? (changes.old?.[key] ? 'Enable' : 'Disable')
                    : key === 'fee_apply_date'
                        ? formatDate(changes.old?.[key])
                        : capitalizeWords(changes.old?.[key]) || "--"
            }));

        setState((draft) => {
            draft.selectedData = result;
            draft.isModalOpen = true;
            draft.selectedDetails = data;
        });
    };

    return {
        state,
        handleModal
    };
};
